import { categories } from "@redotech/redo-model/advanced-flow/triggers";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const sendDraftMessageInput = z.object({
  messageId: zExt.objectId(),
  content: z.string(),
  category: createEnum(categories),
});

const sendDraftMessageOutput = z.object({
  success: z.boolean(),
  errorMessage: z.string().optional(),
  flaggedForReview: z.boolean().optional(),
});

export const adminSendDraftMessage = {
  name: "adminSendDraftMessage" as const,
  input: sendDraftMessageInput,
  output: sendDraftMessageOutput,
};

export const contractorSendDraftMessage = {
  name: "contractorSendDraftMessage" as const,
  input: sendDraftMessageInput,
  output: sendDraftMessageOutput,
};
